import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PermissionsService } from '@core/services/auth/permissions.service';
import { environment } from '@environments/environment';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { combineLatest, map, Observable, tap } from 'rxjs';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  imports: [TranslatePipe, TranslateModule, RouterModule, CommonModule, TegelModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-stencil-side-menu',
  templateUrl: './stencil-side-menu.component.html',
  styleUrls: ['./stencil-side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StencilSideMenuComponent {
  readonly expandedStateChanged = output<boolean>();

  private permissionService = inject(PermissionsService);
  private launchDarklyService = inject(LaunchDarklyService);

  envName = environment.name;

  viewDepartureScheduling$: Observable<boolean> = combineLatest([
    this.permissionService.user_has_FunctionalPermission(['ViewChargingDashboard']),
    this.permissionService.user_has_userPermission(['ViewDepartureScheduling']),
  ]).pipe(map(([hasFunctionalPermission, hasUserPermission]) => hasFunctionalPermission && hasUserPermission));

  /*
                  *************** IMPORTANT ***************
     BEV CONTROL MEANS = functional permission ViewChargingDashboard
     Business uses Bev Control word, which has no meaning to us (as developers)
  */
  viewOverviewLink: boolean = false;

  ViewChargingDashboard$: Observable<boolean> = combineLatest([
    this.permissionService.user_has_FunctionalPermission(['ViewChargingDashboard']),
    this.permissionService.user_has_userPermission(['ViewChargingDashboard']),
  ]).pipe(
    map(([hasFunctionalPermission, hasUserPermission]) => hasFunctionalPermission && hasUserPermission),
    tap((viewDashboard) => (viewDashboard ? '' : (this.viewOverviewLink = true))),
  );

  viewChargingDashboardFunc$: Observable<boolean> = this.permissionService.user_has_FunctionalPermission([
    'ViewChargingDashboard',
  ]);

  viewChargingSettings$: Observable<boolean> = combineLatest([
    this.permissionService.user_has_FunctionalPermission(['ViewChargingDashboard']),
    this.permissionService.user_has_userPermission(['ViewChargingSettings']),
  ]).pipe(map(([hasfuncPermission, hasuserPermission]) => hasfuncPermission && hasuserPermission));

  // LD FLAGS
  viewMap = this.launchDarklyService.isFlagOn('ViewMap');
  viewPublicCharging = this.launchDarklyService.isFlagOn('ViewPublicCharging');
  viewAdmin = this.launchDarklyService.isFlagOn('Admin');
  viewVasBlack = this.launchDarklyService.isFlagOn('ViewVasBlack');

  sideMenuStateChanged(event: Event) {
    this.expandedStateChanged.emit((event as CustomEvent<boolean>).detail);
  }
}
